var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SmallTitle',{attrs:{"text":"Format"}}),_vm._l((Object.values(_vm.fileFormats)),function(format){return _c('Chip',{key:`format-${format}`,attrs:{"name":"format","title":format,"value":format,"checked":_vm.selectedFileFormat === format},on:{"change":_vm.setFileFormat}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }